/* ============================================================
   Capira Premium JS — assets/capira-premium.js
   Scroll reveals · Parallax · Spotlight · Particles · Counters
   ============================================================ */
(function(){
  'use strict';

  /* ── Scroll reveal (data-reveal) ─────────────────────── */
  function initReveal(){
    var els = document.querySelectorAll('[data-reveal]');
    if(!els.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('revealed');
          obs.unobserve(e.target);
        }
      });
    },{ threshold: 0.1, rootMargin:'0px 0px -32px 0px' });
    els.forEach(function(el){ obs.observe(el); });
  }

  /* ── Parallax (data-parallax) ─────────────────────────── */
  function initParallax(){
    var els = document.querySelectorAll('[data-parallax]');
    if(!els.length) return;
    var ticking = false;
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        els.forEach(function(el){
          var speed = parseFloat(el.dataset.parallaxSpeed||'0.14');
          var parent = el.closest('section') || el.parentElement;
          var rect = parent.getBoundingClientRect();
          var mid = rect.top + rect.height/2 - window.innerHeight/2;
          el.style.transform = 'translateY('+(mid*speed).toFixed(1)+'px)';
        });
        ticking = false;
      });
    },{ passive:true });
  }

  /* ── Spotlight cards (mouse tracking) ──────────────────── */
  function initSpotlight(){
    document.querySelectorAll('.capira-spotlight').forEach(function(card){
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        card.style.setProperty('--capira-mouse-x',((e.clientX-r.left)/r.width*100).toFixed(1)+'%');
        card.style.setProperty('--capira-mouse-y',((e.clientY-r.top)/r.height*100).toFixed(1)+'%');
      });
    });
  }

  /* ── Animated counters (data-counter) ────────────────────── */
  function animateCounter(el){
    var target = parseFloat(el.dataset.counter);
    var prefix = el.dataset.counterPrefix||'';
    var suffix = el.dataset.counterSuffix||'';
    var dec = parseInt(el.dataset.counterDecimals||'0');
    var dur = 1800;
    var start = performance.now();
    function ease(t){ return 1-Math.pow(1-t,3); }
    (function step(now){
      var p = Math.min((now-start)/dur,1);
      el.textContent = prefix+( target*ease(p) ).toFixed(dec)+suffix;
      if(p<1) requestAnimationFrame(step);
    })(start);
  }
  function initCounters(){
    var els = document.querySelectorAll('[data-counter]');
    if(!els.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){ animateCounter(e.target); obs.unobserve(e.target); }
      });
    },{ threshold:0.5 });
    els.forEach(function(el){ obs.observe(el); });
  }

  /* ── Canvas particles (data-particles on <canvas>) ─────────── */
  function initParticles(){
    document.querySelectorAll('[data-particles]').forEach(function(canvas){
      var ctx = canvas.getContext('2d');
      if(!ctx) return;
      var count = parseInt(canvas.dataset.particleCount||'55');
      var spd = parseFloat(canvas.dataset.particleSpeed||'0.28');
      function resize(){ canvas.width=canvas.offsetWidth; canvas.height=canvas.offsetHeight; }
      resize();
      window.addEventListener('resize', resize, {passive:true});
      var pts = [];
      for(var i=0;i<count;i++) pts.push({
        x:Math.random()*canvas.width, y:Math.random()*canvas.height,
        r:Math.random()*1.4+0.3,
        dx:(Math.random()-.5)*spd, dy:(Math.random()-.5)*spd*.5-spd*.3,
        a:Math.random()*.35+0.08, ad:(Math.random()>.5?1:-1)*.003
      });
      (function draw(){
        ctx.clearRect(0,0,canvas.width,canvas.height);
        pts.forEach(function(p){
          p.x+=p.dx; p.y+=p.dy; p.a+=p.ad;
          if(p.a<0.06||p.a>0.48) p.ad*=-1;
          if(p.x<0) p.x=canvas.width;
          if(p.x>canvas.width) p.x=0;
          if(p.y<0) p.y=canvas.height;
          if(p.y>canvas.height) p.y=0;
          ctx.beginPath();
          ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
          ctx.fillStyle='rgba(96,165,250,'+p.a.toFixed(2)+')';
          ctx.fill();
        });
        requestAnimationFrame(draw);
      })();
    });
  }

  /* ── Chat loop (cph-chat with data-chat-loop) ─────────────── */
  function initChatLoop(){
    document.querySelectorAll('.cph-chat[data-chat-loop]').forEach(function(chat){
      var msgs = chat.querySelectorAll('.cph-chat__msg, .cph-chat__insight');
      if(!msgs.length) return;
      msgs.forEach(function(m){ m.style.opacity='0'; m.style.transform='translateY(10px)'; m.style.transition='opacity 0.42s ease, transform 0.42s ease'; });
      function cycle(){
        var delay = 500;
        msgs.forEach(function(m){
          setTimeout(function(){ m.style.opacity='1'; m.style.transform='none'; }, delay);
          delay += 1000;
        });
        setTimeout(function(){
          msgs.forEach(function(m){ m.style.opacity='0'; m.style.transform='translateY(-5px)'; });
          setTimeout(function(){ msgs.forEach(function(m){ m.style.transform='translateY(10px)'; }); cycle(); }, 600);
        }, delay+1600);
      }
      cycle();
    });
  }

  /* ── SVG draw-path on scroll ─────────────────────────────── */
  function initDrawPaths(){
    var paths = document.querySelectorAll('.capira-draw-path');
    if(!paths.length) return;
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('revealed'); obs.unobserve(e.target); } });
    },{ threshold:0.25 });
    paths.forEach(function(p){ obs.observe(p); });
  }

  /* ── Boot ────────────────────────────────────────────────── */
  function init(){
    initReveal();
    initParallax();
    initSpotlight();
    initCounters();
    initParticles();
    initChatLoop();
    initDrawPaths();
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
